import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateAnnualLeaveEntitlement } from 'app/dtos/AnnualLeaveEntitlement/updateAnnualLeaveEntitlement';
import { AnnualLeaveEntitlementService } from 'app/services/models/annual-leave-entitlement.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-annual-leave-entitlement-dialog',
  templateUrl: './annual-leave-entitlement-dialog.component.html',
  styleUrls: ['./annual-leave-entitlement-dialog.component.scss']
})
export class AnnualLeaveEntitlementDialogComponent implements OnInit {
  @Input() data: { personId: number, row?: any };

  form: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private annualService: AnnualLeaveEntitlementService) { }

  ngOnInit() {
    console.log(this.data.row);
    this.form = this.fb.group({
      personId: [null, Validators.required],
      year: [null,
        [
          Validators.required, Validators.pattern(/^\d{4}$/), // 4 haneli sayı
          Validators.min(1900),
          Validators.max(2100)
        ]],
      newEntitledDays: [null, Validators.required],
      note: [null, Validators.required],
      carriedOverDays:[0,this.data.row ? [Validators.required] : []]
    });
    if (this.data.personId != null) {
      this.form.patchValue({
        personId: this.data.personId
      })
    }
    if (this.data.row != null) {
      this.form.patchValue({
        personId: this.data.row.personId,
        year: this.data.row.year,
        newEntitledDays: this.data.row.entitledDays,
        note: this.data.row.notes ?? null,
        carriedOverDays:this.data.row.carriedOverDays ?? 0
      })
    }
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }

  async submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValues = this.form.value;
    let response;

    if (this.data.row) {
      // Güncelleme işlemi
      const updateModel: UpdateAnnualLeaveEntitlement = {
        id: this.data.row.id,
        year: formValues.year,
        newEntitledDays: formValues.newEntitledDays,
        note: formValues.note,
        carriedOverDays:formValues.carriedOverDays
      };

      response = await this.annualService.updateAnnualLeaveEntitlement(updateModel);
    } else {
      // Yeni kayıt işlemi
      response = await this.annualService.createAnnualLeaveEntitlement(formValues);
    }

    if (response?.status) {
      this.toastrService.success(response.message);
      this.closeModal(true);
    } else {
      this.toastrService.error(response.message || 'Bir hata oluştu');
    }
  }
}